import { render } from "./UserPrivacy.vue?vue&type=template&id=277bf288&scoped=true"
import script from "./UserPrivacy.vue?vue&type=script&lang=js"
export * from "./UserPrivacy.vue?vue&type=script&lang=js"

import "./UserPrivacy.vue?vue&type=style&index=0&id=277bf288&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277bf288"]])

export default __exports__